import { getAuthHeaders, tempMeeApi } from '~/services/api';

export const publishDraftJobPost = async (id: string): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(`/posting-service/postings/${id}/publish`, {}, { headers });
};
